import { useNavigate } from 'react-router-dom';
import { Button } from '@lex/ui';
import { useAuth } from '../../lib/auth';

export function CtaSection() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <section className="px-4 py-14 md:px-8 md:py-20 xl:px-20">
      <div className="relative mx-auto max-w-[1280px] overflow-hidden rounded-4xl bg-cta-gradient px-6 py-14 text-center md:px-20 md:py-16">
        <h2 className="mx-auto max-w-[900px] text-[30px] font-semibold leading-[1.12] tracking-[-0.025em] text-white md:text-[42px] lg:text-[52px]">
          Не оставайтесь с проблемой один на один
        </h2>
        <p className="mx-auto mt-5 max-w-[680px] text-[16px] leading-[1.5] text-muted-sky md:text-[19px]">
          Опишите ситуацию — юрист подскажет, что делать, и поможет подготовить документы.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-4">
          <Button
            variant="light"
            size="lg"
            className="rounded-xl px-6"
            onClick={() => navigate(isAuthenticated ? '/chat' : '/login')}
          >
            Спросить юриста
          </Button>
          <Button
            variant="outlineDark"
            size="lg"
            className="rounded-xl px-6"
            onClick={() => navigate('/chat')}
          >
            Задать вопрос
          </Button>
        </div>
      </div>
    </section>
  );
}
